export default "__VITE_ASSET__9f354af5__"